"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandler = void 0;
const ErrorHandler = (err) => {
    var _a;
    if (err.isAxiosError) {
        throw new Error(JSON.stringify((_a = err.response) === null || _a === void 0 ? void 0 : _a.data));
    }
    else if (err instanceof Error) {
        throw err;
    }
    else if (typeof err == 'string') {
        throw new Error(err);
    }
    else {
        throw new Error(JSON.stringify(err));
    }
};
exports.ErrorHandler = ErrorHandler;
